'use strict';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

// components
import { ModalStepper } from 'dumb';

// batch view
import MarketGracePeriodsBatchStepList from './components/marketGracePeriodsBatchStepList';

// phrases
import phrases from '../../marketGracePeriods.phrases';

class MarketGracePeriodsModalBatch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loadingModal: false,
		};
	}

	_batchSubmit() {
		const { batchList, handleClose, addMarketGracePeriod } = this.props;

		this.setState(() => ({
			loadingModal: true,
		}));

		const payload = batchList.map((entry) => {
			return {
				...(entry.market?.value?.id && {
					market: entry.market.value.id,
				}),
				early_shift_start: entry.earlyShiftStart,
				early_shift_end: entry.earlyShiftEnd,
				late_shift_start: entry.lateShiftStart,
				late_shift_end: entry.lateShiftEnd,
				break_too_short: entry.breakTooShort,
				break_too_long: entry.breakTooLong,
			};
		});

		addMarketGracePeriod({ batch: payload })
			.then(() => handleClose())
			.finally(() =>
				this.setState(() => ({
					loadingModal: false,
				}))
			);
	}

	render() {
		const {
			modalVisible,
			handleClose,
			batchList,
			editBatchListItem,
			removeBatchListItem,
			addBatchListItemRow,
		} = this.props;

		const steps = [
			{
				component: (
					<MarketGracePeriodsBatchStepList
						batchList={batchList}
						editBatchListItem={editBatchListItem}
						removeBatchListItem={removeBatchListItem}
						productRecommendationUrl={this.productRecommendationUrl}
						tileLayoutUrl={this.tileLayoutUrl}
						ingredientConfigurationUrl={this.ingredientConfigurationUrl}
						addBatchListItemRow={addBatchListItemRow}
					/>
				),
				title: phrases.MODAL_BATCH_STEP_LIST_TITLE,
				isValid: !!batchList?.length,
				onNext: () => this._batchSubmit(),
				loading: this.state.loadingModal,
				confirmButtonLabel: phrases.MODAL_BATCH_STEP_LIST_CONFIRM_BUTTON_LABEL,
				defaultStyles: false,
				noScroll: false,
			},
		];

		return modalVisible ? (
			<ModalStepper
				isOpen={modalVisible}
				steps={steps}
				showStep={false}
				onClose={handleClose}
			/>
		) : null;
	}
}

MarketGracePeriodsModalBatch.propTypes = {
	modalVisible: PropTypes.bool,
	handleClose: PropTypes.func,
	batchList: PropTypes.array,
	editBatchListItem: PropTypes.func,
	removeBatchListItem: PropTypes.func,
	addBatchListItemRow: PropTypes.func,
	addMarketGracePeriod: PropTypes.func,
};

export default MarketGracePeriodsModalBatch;
